export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-1-480-33706beca673ff1bb1a5be0e82fda0a4.webp";